import {remCalc} from '../../_utils'

/**
 * the breadcrumb style
 */
export default {
    baseStyle: {
        wrapper: {
            position: 'relative',
            width: '100%',
            minWidth: 0,
            py: ['small.base', 'small.md', 'small.lg', 'small.xl'],
        },
        container: {
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            overflowX: 'auto',
            overflowY: 'visible',
            whiteSpace: 'nowrap',
            // gives the focus-visible ring's box-shadow (up to 4px spread) room to render before the forced overflow-y clips it
            padding: remCalc(4),
            '::-webkit-scrollbar': {display: 'none'},
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            '.chakra-breadcrumb__list': {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                width: 'max-content',
                minWidth: '100%',
                gap: {
                    base: 'xxxsmall.base',
                    md: 'xxxsmall.md',
                    lg: 'xxxsmall.lg',
                    xl: 'xxxsmall.xl',
                },
            },
        },
        icon: {
            height: remCalc(18),
            width: remCalc(16),
            color: 'foreground.neutral.dim',
        },
        link: {
            color: 'foreground.neutral.subtle',

            _hover: {
                color: 'foreground.neutral.muted',
                textDecoration: 'none',
            },
            _active: {
                color: 'foreground.neutral.muted',
            },
            _focusVisible: {
                color: 'foreground.neutral.default',
                borderRadius: 'medium',
                bg: 'background.neutral.hover',

                boxShadow:
                    '0 1px 2px 0 var(--chakra-shadows-neutral-sm), 0 0 0 2px var(--chakra-colors-background-base-default), 0 0 0 4px var(--chakra-colors-border-accent-light) !important',
            },
        },
        lastLink: {
            cursor: 'none',
            color: 'foreground.neutral.default',
            pointerEvents: 'none',
        },
        item: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            lineHeight: remCalc(18),
            textDecoration: 'none',
        },
        fadeOverlayLeft: {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            height: remCalc(18),
            borderRadius: 0,
            left: 0,
            width: '29%',
            pointerEvents: 'none',
            zIndex: 10,
            backgroundColor: 'var(--chakra-colors-background-base-default)',
            backdropFilter: `blur(${remCalc(4)})`,
            WebkitBackdropFilter: `blur(${remCalc(4)})`,
            maskImage: 'linear-gradient(to right, black 0%, transparent 70%)',
            WebkitMaskImage: 'linear-gradient(to right, black 0%, transparent 70%)',
        },
        fadeOverlayRight: {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            height: remCalc(18),
            borderRadius: 0,
            right: 0,
            width: '29%',
            pointerEvents: 'none',
            zIndex: 10,
            backgroundColor: 'var(--chakra-colors-background-base-default)',
            backdropFilter: `blur(${remCalc(4)})`,
            WebkitBackdropFilter: `blur(${remCalc(4)})`,
            maskImage: 'linear-gradient(to left, black 0%, transparent 70%)',
            WebkitMaskImage: 'linear-gradient(to left, black 0%, transparent 70%)',
        },
    },
    parts: [
        'wrapper',
        'container',
        'icon',
        'link',
        'item',
        'lastLink',
        'separator',
        'fadeOverlayLeft',
        'fadeOverlayRight',
    ],
}
